// components/ProtectedRoute.jsx
// Composant pour protéger les routes : authentification + vérification des permissions
// Supporte les routes accessibles aux anonymes (non connectés)

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasPermission, isAnonymousRoute } from '../config/routePermissions';

export default function ProtectedRoute({ children }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>
        Chargement...
      </div>
    );
  }

  // Si non connecté : vérifier si la route autorise les anonymes
  if (!isAuthenticated) {
    if (isAnonymousRoute(location.pathname)) {
      // Laisser passer : la page gère elle-même le cas anonyme
      return children;
    }
    return <Navigate to="/login" replace />;
  }

  // Connecté : vérifier les permissions par niveau d'abonnement
  if (!hasPermission(location.pathname, user.niveauAcces)) {
    return (
      <div style={{ textAlign: 'center', padding: '3rem' }}>
        <h2 style={{ color: '#dc2626', marginBottom: '1rem' }}>Accès refusé</h2>
        <p style={{ color: '#6b7280' }}>
          Votre abonnement ({user.niveauAcces}) ne permet pas d'accéder à cette page.
        </p>
        <a href="/" style={{ color: '#4f46e5', textDecoration: 'none', fontWeight: 500 }}>
          Retour à l'accueil
        </a>
      </div>
    );
  }

  return children;
}
